import React, { PureComponent } from 'react'
import i18n from 'i18next'
import Slider from 'rc-slider'

const { Handle } = Slider

const handle = (props) => (
    <Handle className="slider-handle" {...props}>
        <div className="slider-handle-container">
            <i className="fas fa-chevron-left" />

            <i className="fas fa-chevron-right" />
        </div>
    </Handle>
)

class ImageSlider extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            value: props.defaultValue,
        }
    }

    onChange = (value) => {
        const { onChange } = this.props
        if (onChange && (typeof onChange === 'function')) {
            onChange(value)
        }
        this.setState({
            value,
        })
    }

    render() {
        return (
            <div class='imageSlider'>
                <div style={{ display: 'flex', alignItems: 'center', gap: 5, marginBottom: 10 }}>
                    <h4>{i18n.t('preview.imageSlider')}</h4>

                    <div className="slider-percent-container">
                        {this.state.value}
                        %
                    </div>
                </div>

                <Slider
                    value={this.state.value}
                    onChange={this.onChange}
                    handle={handle}
                    trackStyle={{
                        backgroundColor: '#16CCC1',
                        height: '4px',
                    }}
                    railStyle={{
                        backgroundColor: '#EFF0F2',
                        height: '4px',
                    }}
                    handleStyle={{
                        backgroundColor: 'white',
                        boxShadow: '3px 5px 8px hsla(0deg, 0%, 0%, 0.08)',
                        height: 24,
                        width: 24,
                        marginTop: -10,
                        border: 'none',
                    }}
                />
            </div>
        )
    }
}

export default ImageSlider
